export const filterActionTypes = {
  SET_FILTERS: 'SET_FILTERS',
  SET_SELECTED_FILTER: 'SET_SELECTED_FILTER'
}